<template>
    <div class="animated fadeIn">
      <b-row class="my-3">
        <b-col>
          <h4 class="text-center text-primary">
            <i class="fa fa-user text-primary mr-2"></i>
            Nuevo Contacto
          </h4>
        </b-col>
      </b-row>
        <b-row class="my-2">
            <b-card class="w-100">
                <b-form @submit.prevent="store" autocomplete="off">
                    <b-row class="pb-2">
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label for="name"><strong>Nombre</strong></label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        id="name"
                                        placeholder="Nombre"
                                        v-model="contact.name"
                                        autocomplete="new-name">
                                    </b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label for="surname"><strong>Apellidos</strong></label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        id="surname"
                                        placeholder="Apellidos"
                                        v-model="contact.surname"
                                        autocomplete="new-surname">
                                    </b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12" md="12">
                            <b-form-group>
                                <label for="email"><strong>Email *</strong></label>
                                <b-input-group>
                                    <b-form-input
                                        type="email"
                                        id="email"
                                        placeholder="Email"
                                        autocomplete="off"
                                        v-model="contact.email"
                                        required>
                                    </b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                  <location-contact-form
                    :input-size="'6'"
                    @community-change="community => {contact.address.name = community}"
                    @province-change="province => {contact.address.province = province}"
                    @town-change="town => {contact.address.town = town}"
                    @postal-code-change="postalCode => {contact.address.postalCode = postalCode}"
                    @address-change="address => {contact.address.address = address}">
                  </location-contact-form>
                  <b-row>
                    <b-col sm="12" md="12">
                      <b-form-group
                        label="<strong>Listas de Distribución</strong>"
                        label-for="distribution"
                        :horizontal="false"
                        class="w-100">
                        <multiselect
                          name="distribution"
                          v-model="contact.distributions"
                          :options="distributions.map(type => type.uuid)"
                          :custom-label="opt => distributions.find(x => x.uuid  === opt).name"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Distribución"
                          selectLabel="+"
                          deselectLabel="-">
                        </multiselect>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" md="12">
                      <b-form-group
                        label="<strong>Preferencias dadas de baja</strong>"
                        label-for="unsubscribe"
                        :horizontal="false"
                        class="w-100">
                        <multiselect
                          name="unsubscribe"
                          v-model="contact.campaignTypes"
                          :options="campaignTypes.map(type => type.uuid)"
                          :custom-label="opt => campaignTypes.find(x => x.uuid  === opt).name"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Darse De Baja"
                          selectLabel="+"
                          deselectLabel="-">
                        </multiselect>
                      </b-form-group>
                    </b-col>
                  </b-row>
                    <b-row>
                        <div class="col float-left">
                            <button
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="!generalValidate()"
                                v-if="mixinCheckPermission('CONTACT_NEW')">
                                Guardar
                            </button>
                        </div>
                    </b-row>
                </b-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {getDistributions} from '@/api/distribution-list-api';
    import locationContactForm from "@/components/location/LocationContactForm.vue";
    import {getCampaignTypes} from "@/api/campaign-type-api";

    export default {
        name: 'addContact',
        components: {
            locationContactForm,
            Multiselect,
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getDistributions();
            this.getCampaignTypes();
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Volver', path: '/communications/contacts/list', brand: 'fa fa-arrow-left'},
                ],
                distributions: [],
                campaignTypes: [],
                contact: {
                    unsubscribe: false,
                    name: null,
                    surname: null,
                    email: null,
                    distributions: [],
                    campaignTypes: [],
                    address: {
                        name: null,
                        address: null,
                        town: null,
                        postalCode: null,
                        province: null,
                        main: true
                    }
                },
                visible: false
            }
        },
        methods: {
            store() {
                this.$_loadingMixin_showLoading();
                let properties = Object.assign({}, this.contact);
                axios.post('contacts', properties)
                    .then((response) => {
                        this.$_loadingMixin_hideLoading();
                        if (response.status == "201") {
                            this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                            this.$router.push({path: '/communications/contacts/list'});
                        }
                    })
                    .catch((error) => {
                        this.$_loadingMixin_hideLoading();
                        this.showApiError(error.response);
                    });
            },
            async getDistributions() {
                this.$_loadingMixin_showLoading();
                await getDistributions()
                    .then((distributions) => {
                        this.distributions = distributions.distributionLists;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getCampaignTypes() {
              this.$_loadingMixin_showLoading();
              await getCampaignTypes()
                .then((campaignTypes) => {
                  this.campaignTypes = campaignTypes.campaignTypes;
                });
              this.$_loadingMixin_hideLoading();
            },
            generalValidate() {
                if (!this.contact.email) {
                  return false;
                } else {
                    return true;
                }
            },
            showApiError(response) {
                if (response.status == 400) {
                  debugger;
                  this.$_notificationMixin_error('Error al guardar el contacto', 'Algo salió mal');
                }
            }
        }
    }
</script>
